// frontend/src/pages/LeaveStatus.jsx
import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout.jsx';
import axiosInstance from '../services/axiosInstance';
import { toast, Toaster } from 'react-hot-toast';

const LeaveStatus = () => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('all');

  const fetchLeaves = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/api/leaves/my');
      if (res.data.success) setLeaves(res.data.data);
      else toast.error(res.data.message || 'Failed to load');
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Failed');
    } finally { 
      setLoading(false);
    }
  };

  useEffect(() => { fetchLeaves(); }, []);

  const filteredLeaves = filter === 'all' ? leaves : leaves.filter(l => l.status === filter);
  
  const counts = {
    all: leaves.length,
    pending: leaves.filter(l => l.status === 'pending').length,
    approved: leaves.filter(l => l.status === 'approved').length,
    rejected: leaves.filter(l => l.status === 'rejected').length
  };

  const getStatusBadge = (status) => {
    const badges = {
      approved: 'bg-success',
      pending: 'bg-warning text-dark',
      rejected: 'bg-danger'
    };
    return badges[status] || 'bg-secondary';
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <Layout>
      <Toaster position="top-right" />
      <div className="container mt-4">
        <div className="card shadow-sm">
          <div className="card-header bg-white py-3">
            <h5 className="mb-0">
              <i className="fas fa-clock text-primary me-2"></i>
              Leave Status
            </h5>
          </div>
          <div className="card-body">
            {/* Stats Cards */}
            <div className="row text-center mb-4 g-2">
              <div className="col-3">
                <div className="border rounded p-2" onClick={() => setFilter('all')} style={{ cursor: 'pointer' }}>
                  <div className="h5 mb-0">{counts.all}</div>
                  <small>Total</small>
                </div>
              </div>
              <div className="col-3">
                <div className="border rounded p-2 bg-warning bg-opacity-10" onClick={() => setFilter('pending')} style={{ cursor: 'pointer' }}>
                  <div className="h5 mb-0">{counts.pending}</div>
                  <small>Pending</small>
                </div>
              </div>
              <div className="col-3">
                <div className="border rounded p-2 bg-success bg-opacity-10" onClick={() => setFilter('approved')} style={{ cursor: 'pointer' }}>
                  <div className="h5 mb-0">{counts.approved}</div>
                  <small>Approved</small>
                </div>
              </div>
              <div className="col-3">
                <div className="border rounded p-2 bg-danger bg-opacity-10" onClick={() => setFilter('rejected')} style={{ cursor: 'pointer' }}>
                  <div className="h5 mb-0">{counts.rejected}</div>
                  <small>Rejected</small>
                </div>
              </div>
            </div>

            {/* Leave List */}
            {loading ? (
              <div className="text-center py-4">Loading...</div>
            ) : filteredLeaves.length === 0 ? (
              <div className="text-center py-4 text-muted">No leave requests found</div>
            ) : (
              <div className="list-group">
                {filteredLeaves.map(leave => (
                  <div key={leave.id} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <strong className="text-capitalize">{leave.leave_type}</strong>
                        <div className="small text-muted">
                          {formatDate(leave.from_date)} - {formatDate(leave.to_date)}
                          {leave.half_day === 1 && <span className="badge bg-secondary ms-2">Half Day</span>}
                        </div>
                        <div className="small mt-1">{leave.reason}</div>
                        {leave.review_notes && leave.status !== 'pending' && (
                          <div className="small text-muted mt-1">
                            <i className="fas fa-comment"></i> {leave.review_notes}
                          </div>
                        )}
                      </div>
                      <div className="text-end">
                        <span className={`badge ${getStatusBadge(leave.status)}`}>
                          {leave.status}
                        </span>
                        <div className="small text-muted mt-1">
                          {formatDate(leave.created_at)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LeaveStatus;